module.exports = __webpack_public_path__ + "static/media/S4N8-1.bb2b3877.svg";